import React from "react";
import cssClasses from "./TemplateMapping.module.css";
import { Box, Modal } from "@mui/material";
import Close from "../Icons/Close";
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  height: "fit-Content",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
};

const PreviewTemplateModal = ({ open, handleClose, selectedTempleteData}) => {
  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>
                    Preview Unit Type
                  </Box>
                </Box>
              </Box>
              <Box
                ml={"auto"}
                mt={1}
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              >
                <Close width={"1.2rem"} height={"1.2rem"} />
              </Box>
            </Box>
          </Box>
          <Box
            padding={"2rem 3rem"}
            display={"flex"}
            flexDirection={"column"}
            gap={"2rem"}
          >
            <div>
              <CustomInput
                disabled={true}
                label={"Payment Plan"}
                placeholder={selectedTempleteData?.paymentPlanName}
                inputType={"text"}
              />
            </div>
            <div>
              <CustomInput
                disabled={true}
                label={"Tempate Id"}
                placeholder={selectedTempleteData.templateId}
                inputType={"number"}
              />
            </div>
            <div>
              <CustomInput
                disabled={true}
                label={"Template Name"}
                placeholder={selectedTempleteData?.templateName}
                inputType={"text"}
              />
            </div>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PreviewTemplateModal;
